import React from 'react'
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import ListGroupItem from 'react-bootstrap/ListGroupItem'

const SolutionCard = (props) => {
    var popover = (
        <Popover id={`${props.stype}_popover`}>
            <Popover.Title as="h3">Details</Popover.Title>
            <Popover.Content>
                <ListGroup className="list-group-flush" >
                    {props.listElements.map((elem, index) => { return <ListGroupItem as="div" key={`${props.type}_${index}`}>{elem}</ListGroupItem> })}
                </ListGroup>
            </Popover.Content>
        </Popover>
    );
    return (
        <Card className="text-center">
            <Card.Header>{props.header}</Card.Header>
            <Card.Body>
                <Card.Title>{props.title}</Card.Title>
                <Card.Text>
                    <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                        <Button className="solution_button" variant="success">Details</Button>
                    </OverlayTrigger>
                </Card.Text>
            </Card.Body>
            <Card.Footer className="text-muted">{`${props.cost} €`}</Card.Footer>
        </Card>
    );
}
export default SolutionCard;